module.exports = __webpack_public_path__ + "media/you-create-we-handle-rest.87dbf607.mp4";